import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';
import axios from 'axios';
import get from 'lodash/get';
import { STATES as ENGINE_STATES, VIDEO_EVENTS } from 'playable/dist/src/constants';

const PING_INTERVAL = 5000;

export default class LiveVideoCounter extends React.Component {
  static propTypes = {
    videoItem: PropTypes.object,
    eventEmitter: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.streamPingUrl = get(props, 'videoItem.streamPingUrl');
  }

  componentDidMount() {
    const { eventEmitter } = this.props;
    if (!this.streamPingUrl) {
      return;
    }
    eventEmitter.on(VIDEO_EVENTS.STATE_CHANGED, this.onStateChanged);
  }

  componentWillUnmount() {
    const { eventEmitter } = this.props;
    this.stopPollCounterService();
    eventEmitter.off(VIDEO_EVENTS.STATE_CHANGED, this.onStateChanged);
  }

  @autobind
  onStateChanged({ nextState, prevState }) {
    if (nextState === ENGINE_STATES.PLAYING && nextState !== prevState) {
      this.startPollCounterService();
    } else if (nextState === ENGINE_STATES.PAUSED) {
      this.stopPollCounterService();
    }
  }

  @autobind
  startPollCounterService() {
    if (this.counterIntervalId) {
      return;
    }
    this.counterIntervalId = setInterval(this.pingCounterService, PING_INTERVAL);
  }

  @autobind
  stopPollCounterService() {
    clearInterval(this.counterIntervalId);
    this.counterIntervalId = null;
  }

  @autobind
  pingCounterService() {
    axios.get(this.streamPingUrl);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/containers/live-video-updaters/components/live-video-counter.js